import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg from '../../Svg';
const OptionsIcon = ({ size, ...rest }) => {
    return (_jsxs(Svg, { size: size, viewBox: "0 0 24 24", ...rest, children: [_jsx("circle", { cx: "5.25", cy: "12", r: "1.625", fill: "#373D42", stroke: "#373D42", strokeWidth: "0.25" }), _jsx("circle", { cx: "12", cy: "12", r: "1.625", fill: "#373D42", stroke: "#373D42", strokeWidth: "0.25" }), _jsx("circle", { cx: "18.75", cy: "12", r: "1.625", fill: "#373D42", stroke: "#373D42", strokeWidth: "0.25" })] }));
};
export default OptionsIcon;
//# sourceMappingURL=OptionsIcon.js.map